import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Model.module.css';
import Eyebrow from '../ui/Eyebrow';

const stackLayers = [
  { label: 'AI / Agentic', desc: 'Agent workflows, LLM orchestration' },
  { label: 'Orchestration', desc: 'Workflow automation, task routing' },
  { label: 'Inference', desc: 'Model serving, latency optimization' },
  { label: 'Security', desc: 'Auth, access control, audit logging' },
  { label: 'Data Intelligence', desc: 'Pipelines, warehousing, analytics' }
];

export default function Model() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.15 });

  return (
    <section className={styles.model} id="model" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <div className={styles.content}>
          <Eyebrow>THE MODEL</Eyebrow>
          <h2 className={styles.heading}>A different kind of venture model.</h2>
          <div className={styles.body}>
            <p>Traditional venture capital provides capital without operational infrastructure. Venture firms provide operational support without a unifying technical foundation. Infundra, as a venture platform, eliminates both constraints.</p>
            <p>The platform entity owns and operates a multi-layered, production-grade technology stack spanning AI and agentic systems, workflow orchestration, inference infrastructure, security architecture, and data intelligence. This stack is built, integrated, and in production, deployed once and inherited by every portfolio company. The platform is currently advancing toward SOC 2 Type 1 certification.</p>
            <p>Partners invest in the platform entity and hold equity exposure across every company deployed on the stack.</p>
          </div>
        </div>
        <div className={styles.stackDiagram}>
          {stackLayers.map((layer, i) => (
            <div
              key={layer.label}
              className={styles.stackLayer}
              style={{ opacity: isInView ? 1 : 0, transform: isInView ? 'translateX(0)' : 'translateX(20px)', transition: `all 0.4s ease ${i * 0.1}s` }}
            >
              <div className={styles.stackLabel}>{layer.label}</div>
              <div className={styles.stackDesc}>{layer.desc}</div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
